export const VARIANTS = {
  DEFAULT: '',
  MINIMALIST: 'minimalist',
  EXTRA_SMALL: 'extraSmall',
};
